import React from 'react';
import styled from 'styled-components/macro';
import { warningMessages, twitterURL} from 'utils/config';

const Wrapper = styled.div`
  margin: 24px auto;
  padding: 24px 40px 24px 16px;
  background-color: #f3db2a;
  color: black;
  width: 100%;
  max-width: 800px;
  border-radius: 3px;
`;

const WarningMessage = () => {
  if (warningMessages[0] !== '') {
    return (
      <Wrapper>
        {
          warningMessages.map(message => (
            <div>{ message }</div>
          ))
        }
        <div>
          We will provide updates on Twitter&nbsp;
          <a href={twitterURL} rel="noopener noreferrer">@EulerBeats</a>
        </div>
      </Wrapper>
    )
  }

  return null;
}

export default WarningMessage;
